import { render } from "./Results.vue?vue&type=template&id=24aad150&scoped=true"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import "./Results.vue?vue&type=style&index=0&id=24aad150&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-24aad150"

export default script